import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Loader from "../Common/Loader";
import CommonService from "../../services/common.service";
const BlogDetail = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let params = useParams(); // calling the hook
  var slug = params.slug;
  useEffect(() => {
    setIsLoading(true);
    CommonService.getBlogDetails(slug).then((res) => {
      if (res.status === 200) {
        setData(res.data);
        setIsLoading(false);
      }
    });
  }, [slug]);

  const changeText = (txt) => {
    const regex = /(<([^>]+)>)/gi;
    const newString = txt.replace(regex, "");
    var ans = newString.substring(150, newString.indexOf(" "));
    return ans;
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="tab-content">
              <div className="backbtn">
                <a href="blog.html" className="btn btn-primary">
                  <i className="fas fa-arrow-left"></i>back
                </a>
              </div>
              <div className="blogsection">
                <div className="left-blog">
                  <div className="bloglist">
                    <div className="blogbox noborder">
                      <figure>
                        <a href="">
                          <img src="images/Blog-image2.png" alt="image" />
                        </a>
                      </figure>
                      <div className="blogcontent">
                        <div className="date">
                          <span>
                            <i className="far fa-calendar-check"></i> Sep 25,
                            2021
                          </span>
                          <span>
                            <i className="far fa-folder-open"></i> Cricket
                          </span>
                          <ul className="sponsor-social">
                            <li>
                              <a href="">
                                <i className="fab fa-facebook-f"></i>
                              </a>
                            </li>
                            <li>
                              <a href="">
                                <i className="fab fa-twitter"></i>
                              </a>
                            </li>
                            <li>
                              <a href="">
                                <i className="fab fa-linkedin-in"></i>
                              </a>
                            </li>
                            <li>
                              <a href="">
                                <i className="fab fa-instagram"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <h3>
                          <a href="0">{data?.name}</a>
                        </h3>
                        <p>{changeText(data?.description)}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="right-blog">
                  <div className="searchbox">
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search"
                    />
                    <button type="submit" className="submit-btn">
                      <img src="images/search-icon.png" alt="image" />
                    </button>
                  </div>
                  <div className="categorybox">
                    <select className="form-control">
                      <option selected="selected">Select Category</option>
                      <option>Basketball</option>
                      <option>Clubs</option>
                      <option>Cricket</option>
                      <option>Football</option>
                      <option>Footy</option>
                      <option>Hockey</option>
                      <option>MCT Fantasy</option>
                      <option>MyClubtap</option>
                      <option>Netball</option>
                      <option>Players</option>
                    </select>
                  </div>
                  <div className="related-blog">
                    <h3>Latest Posts</h3>
                    <ul>
                      <li>
                        <a href="">Lorem Ipsum is simply dummy text</a>
                      </li>
                      <li>
                        <a href="">Lorem Ipsum is simply dummy text</a>
                      </li>
                      <li>
                        <a href="">Lorem Ipsum is simply dummy text</a>
                      </li>
                      <li>
                        <a href="">Lorem Ipsum is simply dummy text</a>
                      </li>
                      <li>
                        <a href="">Lorem Ipsum is simply dummy text</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
